import { useEffect, useState } from "react";
import type { GrapeshotDataObject } from "@app/types/Drupal";
import * as Sentry from "@sentry/react";
import { GRAPESHOT_API_ENDPOINT } from "@util/constant";
import axios, { HttpStatusCode } from "axios";

type GrapeshotResponse = {
  channels: GrapeshotDataObject[];
};

const fetchGrapeshotChannels = async (
  article_url: string
): Promise<GrapeshotDataObject[]> => {
  const response = await axios.get<GrapeshotResponse>(
    `${GRAPESHOT_API_ENDPOINT}${article_url}`
  );
  return response.status === HttpStatusCode.Ok ? response.data.channels : [];
};

/**
 * Description: It returns Grapeshot data
 * @returns data - {GrapeshotDataObject[]}
 */
export default function useGrapeshot(
  article_url: string
): GrapeshotDataObject[] {
  const [data, setData] = useState<GrapeshotDataObject[]>([]);

  useEffect(() => {
    const callFetch = async () => {
      setData(await fetchGrapeshotChannels(article_url));
    };

    try {
      callFetch();
    } catch (error) {
      Sentry.captureException(error);
    }
  }, [article_url]);

  return data;
}
